module.exports = __webpack_public_path__ + "img/1585879488.6655d23f.jpg";